import { Injectable } from '@angular/core';
import { NotesService } from './notes.service';

export interface Scale {
  note12: number;
  note?: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class ScalesService {
  public intervalsDisplay = [
    'R', 'b2', '2', 'b3',
    '3', '4', 'b5', '5',
    '#5', '6', 'b7', '7',
    'T', 'b9', '9', '#9',
    'b11', '11', '#11', '',
    'b13', '13', '#13', ''];
    
  public byFamily: { [category: string]: {[name: string]: number[]} } = {
    commons: {
      'major ': [0, 2, 4, 5, 7, 9, 11],
      'minor (natural)': [0, 2, 3, 5, 7, 8, 10],
      'melodic minor': [0, 2, 3, 5, 7, 9, 11],
      'harmonic major': [0, 2, 4, 5, 7, 8, 11],
      'harmonic minor': [0, 2, 3, 5, 7, 8, 11],
      'pentatonic major': [0, 2, 4, 7, 9],
      'pentatonic minor': [0, 3, 5, 7, 10],
      'blues major': [0, 2, 3, 4, 7, 9],
      'blues minor': [0, 3, 5, 6, 7, 10]
    },
    modes: {
      'ionian (major)': [0, 2, 4, 5, 7, 9, 11],
      dorian: [0, 2, 3, 5, 7, 9, 10],
      phrygian: [0, 1, 3, 5, 7, 8, 10],
      lydian: [0, 2, 4, 6, 7, 9, 11],
      mixolydian: [0, 2, 4, 5, 7, 9, 10],
      'aeolian (minor)': [0, 2, 3, 5, 7, 8, 10],
      locrian: [0, 1, 3, 5, 6, 8, 10]
    },
    greek: {
      'dorian greek': [0, 1, 3, 5, 7, 8, 10],
      'hijaz major': [0, 1, 5, 6, 8, 9, 10],
      'hijazskiar major': [0, 1, 4, 5, 7, 8, 11],
      houseini: [0, 2, 3, 4, 5, 7, 8, 9, 10],
      'houzam I major': [0, 3, 4, 5, 7, 9, 11],
      'houzam II': [0, 1, 4, 6, 7, 9, 11],
      hyperaeolian: [0, 1, 3, 5, 6, 8, 10],
      hyperdorian: [0, 1, 3, 5, 6, 8, 10],
      hyperphrygian: [0, 2, 3, 5, 7, 8, 10],
      hypoaeolian: [0, 1, 3, 5, 6, 8, 10],
      hypodorian: [0, 2, 3, 5, 7, 8, 10],
      hypoionian: [0, 2, 4, 5, 7, 9, 10],
      hypolocrian: [0, 2, 4, 6, 7, 9, 11],
      hypolydian: [0, 2, 4, 6, 7, 9, 11],
      hypomixolydian: [0, 2, 3, 5, 7, 9, 10],
      hypophrygian: [0, 2, 4, 5, 7, 9, 10],
      'ionian iastian': [0, 2, 4, 5, 7, 9, 10],
      kartzihiar: [0, 2, 3, 5, 6, 9, 10],
      'kiourdi minor': [0, 2, 3, 5, 6, 7, 8, 9, 10],
      'kiourdi ascending': [0, 2, 3, 5, 6, 9, 10],
      'kiourdi descending': [0, 2, 3, 5, 7, 8, 10],
      'lydian (greek)': [0, 2, 4, 5, 7, 9, 11],
      'mixolydian greek': [0, 1, 3, 5, 6, 8, 10],
      neveseri: [0, 1, 3, 6, 7, 8, 10, 11],
      'niaventi minor': [0, 2, 3, 6, 7, 8, 11],
      nigriz: [0, 2, 3, 6, 7, 9, 10],
      'olympos enharmonic': [0, 1, 5, 7, 8],
      'ousak minor': [0, 1, 3, 5, 7, 8, 10],
      peiraiotikos: [0, 1, 4, 6, 7, 9, 11],
      'peiraiotikos minor': [0, 2, 3, 6, 7, 9, 10],
      'phrygian greek': [0, 2, 3, 5, 7, 9, 10],
      pireotikos: [0, 1, 4, 6, 7, 8, 11],
      'rast ascending': [0, 2, 4, 5, 7, 9, 11],
      'rast descending': [0, 2, 4, 5, 7, 9, 10],
      'sabach minor': [0, 2, 3, 4, 7, 8, 10],
      sengah: [0, 3, 4, 5, 7, 8, 11],
      'souzinak minor': [0, 2, 3, 6, 7, 9, 10],
      tabahaniotiko: [0, 2, 4, 5, 7, 8, 11],
      tsinganikos: [0, 1, 4, 5, 6, 9, 10],
      'genus diatonicum': [0, 2, 4, 5, 7, 9, 10, 11],  
      'genus d.veterum correctum': [0, 2, 4, 5, 6, 7, 9, 11],
      'genus primum': [0, 2, 5, 7],
      'genus secundum': [0, 4, 5, 7, 9, 11],
      'genus tertium': [0, 3, 4, 7, 8, 11],
      'genus chromaticum': [0, 1, 3, 4, 5, 7, 8, 9, 11]
    },
    spanish: {
      'dorico flamenco': [0, 1, 4, 5, 7, 8, 10],
      'moorish phrygian': [0, 1, 3, 4, 5, 7, 8, 10, 11],
      'spanish major (gypsy)': [0, 1, 4, 5, 7, 8, 10],
      'spanish mode': [0, 1, 3, 5, 7, 8, 10],
      'spanish heptatonic': [0, 3, 4, 5, 6, 8, 10],
      'spanish 5cluster': [0, 1, 3, 4, 5],
      'phrygian I (folk)': [0, 1, 4, 5, 7, 8, 10],
      'phrygian II (flamenco)': [0, 1, 3, 4, 5, 7, 8, 10],
      'phrygian III': [0, 2, 3, 6, 7, 9, 10],
      'eight tone spanish': [0, 1, 3, 4, 5, 6, 8, 10]
    },
    russian: {
      'petrushka chord': [0, 1, 4, 6, 7, 9, 10],
      shostakovich: [0, 1, 3, 4, 6, 7, 9, 11],
      'tcherepnin 9-note mode': [0, 1, 3, 4, 5, 7, 8, 9, 11],
      'tcherepnin maj pent.1': [0, 2, 4, 7, 9],
      'tcherepnin maj pent.2': [0, 2, 5, 7, 11],
      'tcherepnin maj pent.3': [0, 3, 5, 8, 10],
      'tcherepnin maj pent.4': [0, 2, 5, 7, 9],
      'tcherepnin maj pent.5': [0, 3, 5, 7, 10],
      'tcherepnin min pent.1': [0, 2, 3, 7, 8],
      'tcherepnin min pent.2': [0, 1, 5, 6, 10],
      'tcherepnin min pent.3': [0, 4, 5, 9, 11],
      'tcherepnin min pent.4': [0, 1, 5, 7, 8],
      'tcherepnin min pent.5': [0, 4, 6, 7, 11],
      'prokofiev all-bs': [0, 1, 3, 5, 6, 8, 10, 11],
    },
    othereurope: {
      'armenian nihavend': [0, 2, 3, 5, 7, 8, 11],
      'armenian cushak': [0, 2, 3, 5, 7, 8, 10],    // armenian
      'armenian hijaz': [0, 2, 5, 6, 8, 9, 11],     // armenian
      'armenian rast': [0, 2, 4, 5, 7, 9, 11],
      'byzantine liturgical chr.': [0, 1, 4, 5, 7, 8, 11],
      'hungarian folk (gypsy)': [0, 1, 4, 5, 7, 8, 11],
      'hungarian gypsy': [0, 2, 3, 6, 7, 8, 10],
      'hungarian major': [0, 3, 4, 6, 7, 9, 10],
      'hungarian minor': [0, 2, 3, 6, 7, 8, 11],
      'hungarian minor-b2': [0, 1, 2, 3, 6, 7, 8, 11],
      'romanian minor': [0, 2, 3, 6, 7, 9, 10],
      'romanian bacovia': [0, 4, 5, 8, 11],
      'romanian major': [0, 1, 4, 6, 7, 9, 10],
      'minor gypsy': [0, 2, 3, 6, 7, 8, 10, 11],
      'gypsy hexatonic': [0, 1, 4, 5, 7, 8, 9],
      'minor gipsy inverse': [0, 1, 4, 5, 6, 9, 10],
      'neapolitan major': [0, 1, 3, 5, 7, 9, 11],
      'neapolitan minor': [0, 1, 3, 5, 7, 8, 11],
      'neapolitan minor-mode': [0, 1, 2, 4, 6, 8, 9],
      prometheus: [0, 2, 4, 6, 9, 10],
      'prometheus neapol': [0, 1, 4, 6, 9, 10],
      'prometheus liszt': [0, 1, 4, 5, 8, 9],
      'five-note prometheus': [0, 2, 4, 6, 10],
      'pseudo turkish': [0, 1, 3, 5, 6, 9, 10],
      'scottish hexatonic': [0, 2, 4, 5, 7, 9],
      'scottish pentatonic': [0, 2, 5, 7, 9],
      scriabin: [0, 1, 4, 7, 9], /// scottish
      'mischung 1': [0, 2, 3, 5, 7, 9, 11],   // german
      'mischung 2': [0, 2, 4, 5, 7, 8, 11],	// german
      'mischung 3 mixol.': [0, 2, 4, 5, 7, 9, 10], // german
      'mischung 4': [0, 2, 3, 5, 7, 8, 11],  // german
      'mischung 5 dorian': [0, 2, 3, 5, 7, 9, 10],  // german
      'mischung 6': [0, 2, 4, 5, 7, 8, 10]	// german
    },
    otherasian: {
      asian: [0, 3, 5, 7, 10], 
      javanese: [0, 1, 3, 5, 7, 9, 10],
      'javanese pentachord': [0, 1, 3, 6, 7],
      'balinese pelog 1': [0, 1, 3, 7, 8],
      'balinese pelog 2': [0, 1, 3, 7, 10],
      'balinese pentatonic': [0, 1, 4, 6, 7],
      'kubilai\'s mongol': [0, 2, 4, 5, 6, 7, 9, 11],
      'korean kyemyonjo': [0, 3, 5, 7, 9],
      'korean ujo': [0, 2, 5, 7, 9],
      'korean nando-kyemyonjo': [0, 2, 3, 5, 7],
      'korean p\'yongjo': [0, 2, 5, 7, 9, 10],
      'korean p\'yongjo 2': [0, 2, 5, 7, 9],
      'korean p\'yongjo-kyemyonjo': [0, 3, 5, 7, 10]
    },
    japanese: {
      'akebono I': [0, 2, 3, 7, 9],
      'akebono II': [0, 1, 5, 7, 8],
      banshikicho: [0, 2, 3, 4, 7, 9, 10],
      'han-iwato': [0, 1, 5, 7, 10],
      'han-kumoi': [0, 2, 5, 7, 8],
      'hira-joshi': [0, 2, 3, 7, 8],
      honchoshi: [0, 1, 5, 7, 8, 10],
      'honchoshi plagal form': [0, 1, 3, 5, 6, 10],
      'honchoshi 2': [0, 5],
      'hon-kumoi-joshi': [0, 1, 5, 7, 8],
      hyojo: [0, 2, 3, 5, 7, 9, 10],
      in: [0, 1, 2, 5, 7, 8, 9],
      insen: [0, 1, 5, 7, 8, 10],
      'insen 2': [0, 1, 5, 7, 10],
      ichikotsucho: [0, 2, 4, 5, 6, 7, 9, 11],
      iwato: [0, 1, 5, 6, 10],
      'japanese mode': [0, 2, 3, 7, 8],
      'kata-kumoi': [0, 2, 3, 7, 8],
      'kokin-joshi': [0, 1, 5, 7, 10],
      minyo: [0, 3, 5, 8, 10],
      'miyako-bushi 1': [0, 1, 2, 5, 7, 8, 9],
      'miyako-bushi 2': [0, 1, 5, 7, 10],
      niagari: [0, 1, 5, 7, 8, 10],
      'niagari 2': [0, 7],
      'nohkan flute': [0, 2, 5, 6, 8, 9, 11],
      'oshikicho : japan': [0, 2, 3, 5, 7, 9, 10],
      ritsu: [0, 1, 3, 5, 8, 10],
      'ritsu gagaku': [0, 2, 5, 7, 9],
      ritsusen: [0, 2, 5, 7, 9],
      ryo: [0, 2, 4, 5, 6, 7, 9, 10, 11],
      ryosen: [0, 2, 4, 7, 9],
      ryukyu: [0, 4, 5, 7, 11],
      sakura: [0, 1, 5, 7, 8],
      sansagari: [0, 5, 10],
      taishikicho: [0, 2, 4, 5, 6, 7, 9, 10, 11],
      'takemitsu tree line mode 1': [0, 2, 3, 6, 8, 11],
      'takemitsu tree line mode 2': [0, 2, 3, 6, 8, 10],
      'todi thaat': [0, 1, 3, 5, 7, 8, 10],
      'todi thaat 2': [0, 1, 3, 6, 7, 8, 11],
      'yo (shomyo, gagaku)': [0, 2, 5, 7, 9],
      'yona nuki major': [0, 2, 4, 7, 9],
      'yona nuki minor': [0, 2, 3, 7, 8],
      yosen: [0, 2, 5, 7, 9, 10],
      zokuso: [0, 1, 3, 5, 7, 8, 10]
    },
    maqam: {
      // 'makam hijaz': [0, 1, 4, 5, 7, 8, 10, 11],
      'maqam ajam ashiran': [0, 2, 4, 5, 7, 9, 11],
      'maqam bayat-e-esfahan': [0, 2, 3, 5, 7, 8, 11],
      'maqam bûselik': [0, 2, 3, 5, 7, 8, 11],
      'maqam çârgâh': [0, 2, 4, 5, 7, 9, 11],
      'maqam hedjaz': [0, 2, 3, 6, 7, 9, 10],
      'maqam hicaz': [0, 1, 4, 5, 7, 9, 10],
      'maqam hijaz': [0, 1, 4, 5, 7, 8, 10, 11],
      'maqam hijaz kar': [0, 1, 4, 5, 7, 8, 11],
      'maqam hisar': [0, 2, 3, 6, 7, 8, 11],
      'maqam humayun': [0, 1, 4, 5, 7, 8, 10],
      'maqam huzzam': [0, 1, 3, 4, 7, 8, 10],
      'maqam karcigar': [0, 2, 3, 5, 6, 9, 10],
      'maqam kurd': [0, 1, 3, 5, 7, 8, 10],
      'maqam lami': [0, 1, 3, 5, 6, 8, 10],
      'maqam nahawand': [0, 2, 3, 7, 8, 10],
      'maqam nahawand murassah': [0, 2, 3, 5, 6, 9, 10],
      'maqam nakriz': [0, 2, 3, 6, 7, 9, 10],
      'maqam nawa athar': [0, 2, 3, 6, 7, 8, 11],
      'maqam nihavend': [0, 2, 3, 5, 7, 8, 10],
      'maqam rast': [0, 2, 4, 5, 7, 9, 10, 11],
      'maqam saba zamzam': [0, 1, 3, 4, 7, 8, 10],
      'maqam shadd\'araban': [0, 1, 3, 4, 5, 6, 9, 10],
      'maqam shahnaz kurdi': [0, 1, 3, 5, 7, 8, 11],
      'maqam shawq awir': [0, 2, 4, 5, 7, 9, 10, 11],
      'maqam sultani yakah': [0, 2, 3, 5, 7, 8, 11],
      'maqam suzidil': [0, 1, 4, 5, 7, 8, 11],
      'maqam tarznauyn': [0, 1, 3, 5, 6, 9, 10],
      'maqam ussâk': [0, 2, 4, 5, 7, 8, 10],
      'maqam zanjaran': [0, 1, 4, 5, 7, 9, 10],
      'maqam zengule': [0, 1, 4, 5, 7, 8, 10]
    },
    othermiddleeast: {
      'saudi arabia alhijaz': [0, 1, 4, 5, 7, 8, 10],
      'oriental 5cluster': [0, 1, 2, 5, 6],
      'zirafkend arabia': [0, 2, 3, 5, 7, 8, 9, 11],
      'oriental 1': [0, 1, 4, 5, 6, 8, 10],
      'oriental 2': [0, 1, 4, 5, 6, 9, 10],
      'oriental 3': [0, 1, 4, 5, 6, 9, 10, 11],
      mohammedan: [0, 2, 3, 5, 7, 8, 11],
      arabic: [0, 2, 4, 5, 6, 8, 10], // = major locrian
      persian: [0, 1, 4, 5, 6, 8, 11],
      'byzantine / persian': [0, 1, 4, 5, 7, 8, 11], //
      'syrian pentatonic': [0, 1, 4, 5, 8],
      'iran dastgah mahur': [0, 2, 4, 5, 7, 9, 11],
      'iran dastgah rast panjgah': [0, 2, 4, 5, 7, 9, 11]
    },
    jewish: {
      'ahavah rabbah': [0, 1, 4, 5, 7, 8, 10],
      freygish: [0, 1, 3, 4, 5, 6, 8, 10],
      'chad gadyo': [0, 2, 3, 5, 7],
      'magen abot': [0, 1, 3, 4, 6, 8, 9, 11],
      'adonai malakh': [0, 1, 2, 3, 5, 7, 9, 10],
      misheberekh: [0, 2, 3, 6, 7, 9, 10],
      yishtabach: [0, 1, 3, 5, 6, 8, 10]
    },
    american: {
      'ute tritonic': [0, 3, 10], 		// native american
      'warao ditonic': [0, 10], 			// native american
      'warao tetratonic': [0, 2, 3, 10], // native american
      'warao tritonic': [0, 5, 7], 		// native american
      'peruvian major': [0, 2, 4, 5, 7, 9, 11],
      'peruvian minor': [0, 2, 3, 5, 7, 8, 10],
      'peruvian pentatonic 1': [0, 2, 4, 7, 9],
      'peruvian pentatonic 2': [0, 3, 5, 7, 10],
      'peruvian tritonic 1': [0, 4, 7],
      'peruvian tritonic 2': [0, 3, 9],
      'eskimo heptatonic': [0, 2, 3, 5, 7, 9, 10],
      'eskimo hexatonic 1': [0, 2, 3, 5, 7, 10],
      'eskimo hexatonic 2': [0, 2, 4, 6, 8, 11],
      'eskimo hexatonic 3': [0, 2, 4, 6, 8, 9],
      'eskimo tetratonic': [0, 2, 4, 7],
      'hawaiian 1': [0, 2, 3, 5, 7, 9, 11],
      'hawaiian 2': [0, 2, 3, 7, 9, 11]
    },
    african: {
      'algerian scale': [0, 2, 3, 5, 6, 7, 8, 11],
      egyptian: [0, 2, 5, 7, 10],
      // ethiopian
      'ethio. ambassel': [0, 1, 5, 7, 8],
      'ethio. ararai': [0, 2, 4, 5, 7, 9, 11],
      'ethio. bati': [0, 3, 5, 7],
      ethiopian: [0, 2, 4, 5, 7, 8, 11],
      'ethio. ezel & geez': [0, 2, 3, 5, 7, 8, 10],
      'ethio. kaffa': [0, 2, 3, 6, 7, 9, 10],
      'ethio. tizita major': [0, 2, 4, 7, 9],
      'ethio. tizita minor': [0, 1, 3, 7, 8],
      // end ethiopian
      'ghana heptatonic': [0, 2, 4, 5, 7, 9, 11],
      'ghana pentatonic 1': [0, 2, 3, 5, 7],
      'ghana pentatonic 2': [0, 2, 4, 7, 9],
      tunisian: [0, 2, 3, 6, 7, 9, 10]
    },
    chinese: {
      'ancient chinese': [0, 2, 4, 6, 7, 9],
      'bi yu': [0, 3, 7, 10],
      chiao: [0, 2, 3, 5, 7, 8, 10],
      'chaio two': [0, 2, 5, 8, 10],
      chin: [0, 3, 6, 8, 10],
      chinese: [0, 4, 6, 7, 11],
      ching: [0, 4, 6, 7, 11],
      'eight-note chinese': [0, 2, 4, 5, 7, 9, 10, 11],
      gong: [0, 2, 4, 7, 9],
      gu: [0, 2, 4, 6, 7, 9, 11],
      'gu xian': [0, 3, 5, 7, 10],
      jiao: [0, 3, 5, 8, 10],
      'jia zhong': [0, 3, 5, 7, 10],
      'jin yu': [0, 2, 5, 7, 10],
      kung: [0, 2, 4, 6, 7, 9, 11],
      'kung 2': [0, 2, 4, 6, 9],
      'man gong': [0, 3, 5, 8, 10],
      'man jue': [0, 2, 4, 7, 9],
      'pien chih': [0, 1, 3, 5, 6, 8, 10],
      ping: [0, 2, 4, 6, 7, 9, 11],
      'qing shang': [0, 3, 5, 7, 10],
      'qing yu': [0, 2, 5, 7, 10],
      'quan ming': [0, 3, 5, 8, 10],
      'rui bin': [0, 2, 5, 7, 10],
      se: [0, 2, 3, 5, 7, 8, 10],
      shang: [0, 2, 4, 5, 7, 9, 10],
      'shang 2': [0, 2, 5, 7, 10],
      xin: [0, 2, 4, 5, 7, 9, 11],
      'yi ze': [0, 3, 5, 8, 10],
      youlan: [0, 1, 2, 4, 5, 6, 7, 9, 10],
      yu: [0, 2, 3, 5, 7, 9, 10],
      'yu 2': [0, 3, 5, 7, 10],
      zheng: [0, 2, 5, 7, 9],
      zhi: [0, 2, 5, 7, 9]
    },
    moreblues: {
      'blues major': [0, 2, 3, 4, 7, 9],
      'blues minor': [0, 3, 5, 6, 7, 10],
      'auxiliary dim. blues': [0, 1, 3, 4, 6, 7, 9, 10], // added
      'blues dorian hexat.': [0, 1, 3, 4, 7, 9],
      'blues heptatonic': [0, 3, 5, 6, 7, 9, 10],
      'blues minor maj7': [0, 3, 5, 6, 7, 11],
      'blues modified': [0, 2, 3, 5, 6, 7, 10],
      'blues pentacluster': [0, 1, 2, 3, 6],
      'blues 5cluster 3bs': [0, 1, 2, 3, 5],
      'blues phrygian': [0, 1, 3, 5, 6, 7, 10],
      'with leading tone': [0, 3, 5, 6, 7, 10, 11],
      'blues #5': [0, 3, 5, 6, 11],
      'blues I pentatonic': [0, 3, 5, 6, 10],
      'blues IV octatonic': [0, 2, 3, 5, 6, 7, 9, 10],
      'blues V': [0, 3, 4, 5, 6, 7, 10, 11],
      'blues VI': [0, 3, 4, 5, 6, 7, 9, 10, 11],
      'blues nine-note': [0, 2, 3, 4, 5, 6, 7, 9, 10],
      'bluesy RnR': [0, 3, 4, 5, 7, 9, 10]
    },
    bebop: {
      'bebop major': [0, 2, 4, 5, 7, 8, 9, 11], // = major + 'blue' note
      'bebop minor': [0, 2, 3, 4, 5, 7, 9, 10],
      'bebop dominant': [0, 2, 4, 5, 7, 9, 10, 11],
      'bebop dorian': [0, 2, 3, 4, 5, 7, 9, 10],
      'bebop melodic min.': [0, 2, 3, 5, 7, 8, 9, 11],
      'bebop harmonic min': [0, 2, 3, 5, 7, 8, 10, 11],
      'bebop half-dimin.': [0, 1, 3, 5, 6, 7, 8, 11],
      'major bebop hexat.': [0, 2, 4, 7, 8, 9],
      'major bebop hepta.': [0, 2, 4, 5, 7, 8, 9],
      'minor bebop all bs': [0, 2, 3, 4, 7, 9, 10]
    },
    altmodes: {
      'dorian/aeolian': [0, 2, 3, 5, 7, 8, 9, 10],
      'dorian pentatonic': [0, 2, 3, 7, 9],
      'dorian b5': [0, 2, 3, 5, 6, 9, 10],
      'dorian b2': [0, 1, 3, 5, 7, 9, 10],
      'dorian b2 b5': [0, 1, 3, 5, 6, 9, 10],
      'dorian #4': [0, 2, 3, 6, 7, 9, 10],
      'dorian/major mixed': [0, 2, 3, 4, 5, 7, 9, 10, 11],
      'phrygian major': [0, 1, 4, 5, 7, 8, 10],
      'phrygian/aeolian': [0, 1, 2, 3, 5, 7, 8, 10],
      'phrygian hexatonic': [0, 3, 5, 7, 8, 10],
      'phrygian/locrian': [0, 1, 3, 5, 6, 7, 8, 10],
      'phrygian dominant': [0, 1, 4, 5, 7, 8, 10],
      'phrygian b4': [0, 1, 3, 4, 7, 8, 10],
      'phrygian Pentatonic': [0, 3, 5, 8, 10],
      'double phrygian-hexa': [0, 1, 3, 5, 6, 9],
      'lydian dominant': [0, 2, 4, 6, 7, 9, 10],
      // lydian dominant =
      // overtone(*) / bartok(*) / lydian b7 / acoustic / lydian-mixolydian / mixolydian #4 / raga bhusavati / mela vacaspati
      'lydian/major mixed': [0, 2, 4, 5, 6, 7, 9, 11],
      'lydian augmented': [0, 2, 4, 6, 8, 9, 11],
      'lydian augmented #2': [0, 3, 4, 6, 8, 9, 11],
      'lydian #2': [0, 3, 4, 6, 7, 9, 11],
      'lydian diminished': [0, 2, 3, 6, 7, 9, 11],
      'lydian domin. 7th': [0, 2, 4, 6, 7, 9, 10, 11],
      'lydian hexatonic': [0, 2, 5, 7, 9, 11],
      'lydian b3': [0, 2, 3, 6, 7, 9, 11],
      'lydian pentachord': [0, 2, 4, 6, 7],
      'lydian/mixol. mixed': [0, 2, 4, 5, 6, 7, 9, 10, 11],
      'mixolydian augmented': [0, 2, 4, 5, 8, 9, 10],
      'mixolydian hexatonic': [0, 2, 5, 7, 9, 10],
      'mixolydian penta': [0, 4, 5, 7, 10],
      'mixolydian b5': [0, 2, 4, 5, 6, 9, 10],
      'mixolydian b2': [0, 1, 4, 5, 7, 9, 10],
      'mixolydian altered': [0, 2, 4, 5, 7, 8, 9, 11],
      'mixolydian/major mix': [0, 2, 4, 5, 7, 9, 10, 11],
      'aeolian major': [0, 2, 4, 5, 7, 8, 10],
      'aeolian pentatonic': [0, 3, 5, 7, 10],
      'locrian #2': [0, 2, 3, 5, 6, 8, 10],
      'locrian #6': [0, 1, 3, 5, 6, 9, 10],
      'locrian #2 #6': [0, 2, 3, 5, 6, 9, 10],
      'locrian pentamirror': [0, 1, 3, 5, 6],
      'locrian bb7': [0, 1, 3, 5, 6, 8, 9],
      'locrian #2 b7': [0, 2, 3, 5, 6, 8, 9],
      'locrian diminished': [0, 1, 3, 4, 6, 8, 9],
      'super locrian': [0, 1, 3, 4, 6, 8, 10],
      'locrian major': [0, 2, 4, 5, 6, 8, 10]
    },
    jazzmore: {
      augmented: [0, 3, 4, 7, 8, 11],
      'altered': [0, 1, 3, 4, 6, 8, 10],
      'altered diminished': [0, 1, 3, 4, 6, 8, 9],
      'altered pentatonic': [0, 1, 5, 7, 9],
      'auxiliary augmented': [0, 2, 4, 6, 8, 10], // added
      'auxiliary diminished': [0, 2, 3, 5, 6, 8, 9, 11], // added
      'center cluster 5mirror': [0, 3, 4, 5, 8],
      'dominant pentatonic': [0, 2, 4, 7, 10],
      // 'diatonic': [0, 2, 4, 7, 9],
      'diminished half': [0, 1, 3, 4, 6, 7, 9, 10],
      'diminished whole': [0, 2, 3, 5, 6, 8, 9, 11],
      'dimin. whole tone': [0, 1, 3, 4, 6, 8, 10],
      'half-diminished': [0, 2, 3, 5, 6, 8, 10],
      'dominant 7th': [0, 2, 5, 7, 9, 10] ,
      'double harmonic': [0, 1, 4, 5, 7, 8, 11],
      'enigmatic 1': [0, 1, 4, 6, 8, 10, 11],
      'enigmatic 2': [0, 1, 2, 4, 7, 8, 11],
      'enigmatic 3': [0, 1, 4, 5, 6, 8, 10, 11],
      'enigmatic 4': [0, 1, 4, 5, 8, 10, 11],
      'enigmatic 5': [0, 1, 3, 6, 8, 10, 11],
      'fifth mode': [0, 2, 4, 5, 7, 10],
      'full minor': [0, 2, 3, 5, 7, 8, 9, 10, 11],
      'half dimin-plus-b8': [0, 3, 6, 10, 11],
      'harmonic minor inverse': [0, 1, 4, 5, 7, 9, 10],
      'harmonic and neap.min.': [0, 1, 2, 3, 5, 7, 8, 11],
      'jazz minor inverse': [0, 1, 3, 5, 7, 9, 10],
      'leading whole tone': [0, 2, 4, 6, 8, 10, 11],
      'major diatonic hexa': [0, 2, 4, 5, 7, 9],
      'major minor': [0, 2, 4, 5, 7, 8, 10],
      'major pentachord': [0, 2, 4, 5, 7],
      'major augmented': [0, 2, 4, 5, 8, 9, 11],
      'major/minor mixed': [0, 2, 3, 4, 5, 7, 8, 9, 10, 11],
      'minor hexatonic': [0, 2, 3, 5, 7, 10],
      'nine tone scale': [0, 2, 3, 4, 6, 7, 8, 9, 11],
      overtone: [0, 2, 4, 6, 7, 9, 10],
      'pentatonic neutral': [0, 2, 5, 7, 10],
      'pentatonic maj. b2': [0, 1, 4, 7, 9],
      'pentatonic maj. b2 b5': [0, 1, 4, 6, 9],
      'pentatonic maj. b2 b6': [0, 1, 4, 7, 8],
      'pentatonic maj. b3': [0, 1, 3, 6, 9],
      'pentatonic maj. b3 b6': [0, 2, 3, 7, 8],
      'pentatonic maj. b5': [0, 2, 4, 6, 9],
      'pentatonic maj. b6': [0, 2, 4, 7, 8],
      'pentatonic maj. #9 b7': [0, 3, 4, 7, 10],
      'pentatonic min. add6': [0, 3, 5, 7, 9, 10],
      'pentatonic min/maj 6': [0, 3, 5, 7, 9],
      'pentatonic whole tone': [0, 4, 6, 8, 10],
      'pyramid hexatonic': [0, 2, 3, 5, 6, 9],
      'suspended pentatonic': [0, 2, 5, 7, 10],
      'symmetrical decatonic': [0, 1, 2, 4, 5, 6, 7, 8, 10, 11],
      'six tone symetrical': [0, 1, 4, 5, 8, 9],
      // '3 Semitones': [0, 3, 6, 9],
      'whole tone': [0, 2, 4, 6, 8, 10]
    },
    gregorian: {
      'protus authentus': [0, 2, 3, 5, 7, 9, 10],
      'protus plagis': [0, 2, 3, 5, 7, 8, 10],
      'deuterus authenticus': [0, 1, 3, 5, 7, 8, 10],
      'deuterus plagis': [0, 1, 3, 5, 6, 8, 10],
      'tritus authenticus': [0, 1, 3, 6, 7, 8, 11],
      'tritus plagis': [0, 2, 4, 5, 7, 9, 11],
      'tetrardus authenticus': [0, 2, 4, 5, 7, 9, 10],
      'tetrardus plagis': [0, 2, 3, 5, 7, 9, 10],
      'gregorian 1 ?': [0, 2, 3, 5, 7, 8, 9, 10],
      // tet auth 'gregorian 2': [0, 2, 4, 5, 7, 9, 10],
      'gregorian 2 ?': [0, 1, 3, 5, 7, 8, 10, 11],
      'gregorian 3 ?': [0, 2, 3, 5, 7, 8, 10, 11],
      'gregorian 4 ?': [0, 2, 4, 5, 6, 7, 9, 11],
      'gregorian 5 ?': [0, 2, 4, 5, 7, 9, 10, 11],
      'gregorian 6 ?': [0, 2, 4, 5, 7, 9, 10]
      // tet plag 'gregorian 8': [0, 2, 3, 5, 7, 9, 10]
    },
    messiaens: {
      'messiaen 1': [0, 2, 4, 6, 8, 10],
      'messiaen 2': [0, 1, 3, 4, 6, 7, 9, 10],
      'messiaen 2 inv': [0, 2, 3, 5, 6, 8, 9, 11],
      'messiaen 3': [0, 2, 3, 4, 6, 7, 8, 10, 11],
      'messiaen 4': [0, 1, 2, 5, 6, 7, 8, 11],
      'messiaen 4 inv': [0, 3, 4, 5, 6, 9, 10, 11],
      'messiaen 5': [0, 1, 2, 5, 6, 7, 8, 11],
      'messiaen 6': [0, 2, 4, 5, 6, 8, 10, 11],
      'messiaen 6 inv': [0, 2, 4, 5, 6, 8, 10, 11],
      'messiaen 7': [0, 1, 2, 3, 5, 6, 7, 8, 9, 11],
      'messiaen 7 inv': [0, 2, 3, 4, 5, 6, 8, 9, 10, 11],
      'messiaen trunc 5': [0, 1, 6, 7],
      'messiaen trunc 5 inv': [0, 5, 6, 11],
      'messiaen trunc 6': [0, 2, 6, 8],
      'messiaen trunc 6 inv': [0, 4, 6, 10]
    },
    chromatics: {
      chromatic: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      'chr.dorian': [0, 1, 2, 5, 7, 8, 9],
      'chr.dorian-inv': [0, 3, 4, 5, 7, 10, 11],
      'chr.heptamirror-#': [0, 1, 2, 3, 4, 5, 6],
      'chr.hexamirror-b': [0, 1, 2, 3, 4, 5],
      'chr.hypodorian': [0, 2, 3, 4, 7, 8, 9],
      'chr.hypodorian-inv': [0, 3, 4, 5, 8, 9, 10],
      'chr.hypolydian': [0, 1, 4, 6, 7, 8, 11],
      'chr.hypolydian-inv': [0, 1, 4, 5, 6, 8, 11],
      'chr.hypophrygian-inv': [0, 1, 2, 5, 6, 7, 9],
      'chr.lydian': [0, 1, 4, 5, 6, 9, 11],
      'chr.lydian-inv': [0, 1, 3, 6, 7, 8, 11],
      'chr.mixolydian': [0, 1, 2, 4, 6, 7, 10],
      'chr.mixolydian-inv': [0, 2, 5, 6, 7, 10, 11],
      'chr.octamirror': [0, 1, 2, 3, 4, 5, 6, 7],
      'chr.phrygian': [0, 3, 4, 5, 8, 10, 11],
      'chr.phrygian-inv': [0, 1, 2, 4, 7, 8, 9]
    },
    composers: {
      'Bartok scale': [0, 2, 4, 6, 7, 9, 10],
      'Esplá\'s scale': [0, 1, 3, 4, 5, 6, 8, 10],
      'John Foulds scale': [0, 1, 4, 6, 7, 8, 9], // In Mantra of Will
      'Jeths\' mode scale': [0, 2, 3, 5, 6, 9, 11],
      'Ravel scale': [0, 1, 3, 4, 6, 8, 10],
      'gnossiennes (Satie)': [0, 2, 3, 6, 7, 9, 10],
      'Van der Horst octa.': [0, 1, 3, 5, 6, 7, 9, 11] // dutsch
    },
    indianmela: {
      bhavapriya: [0, 1, 3, 6, 7, 8, 10],
      cakravaka: [0, 1, 4, 5, 7, 9, 10],
      calanata: [0, 3, 4, 5, 7, 10],
      carukesi: [0, 2, 4, 5, 7, 8, 10],
      citrambari: [0, 2, 4, 6, 7, 10, 11],
      dharmavati: [0, 2, 3, 6, 7, 9, 11],
      dhatuvardhani: [0, 3, 4, 6, 7, 8, 11],
      dhavalambari: [0, 1, 4, 6, 7, 8, 9],
      dhenuka: [0, 1, 3, 5, 7, 8, 11],
      divyamani: [0, 1, 3, 6, 7, 10, 11],
      gamanasrama: [0, 1, 4, 6, 7, 9, 11],
      ganamurti: [0, 1, 2, 5, 7, 8, 11],
      gangeyabhusani: [0, 3, 4, 5, 7, 8, 11],
      gaurimanohari: [0, 2, 3, 5, 7, 9, 11],
      gavambodhi: [0, 1, 3, 6, 7, 8, 9],
      gayakapriya: [0, 1, 4, 5, 7, 8, 9],
      harikambhoji: [0, 2, 4, 5, 7, 9, 10],
      hatakambari: [0, 1, 4, 5, 7, 10, 11],
      hemavati: [0, 2, 3, 6, 7, 9, 10],
      jalarnava: [0, 1, 2, 6, 7, 8, 10],
      jhalavarali: [0, 1, 2, 6, 7, 8, 11],
      jhankaradhvani: [0, 2, 3, 5, 7, 8, 9],
      jyotisvarupini: [0, 3, 4, 6, 7, 8, 10],
      kamavardhani: [0, 1, 4, 6, 7, 8, 11],
      kanakangi: [0, 1, 2, 5, 7, 8, 9],
      kantamani: [0, 2, 4, 6, 7, 8, 9],
      kharaharapriya: [0, 2, 3, 5, 7, 9, 10],
      kiravani: [0, 2, 3, 5, 7, 8, 11],
      kokilapriya: [0, 1, 3, 5, 7, 9, 11],
      kosalam: [0, 3, 4, 6, 7, 9, 11],
      latangi: [0, 2, 4, 6, 7, 8, 11],
      manavati: [0, 1, 2, 5, 7, 9, 11],
      mararanjani: [0, 2, 4, 5, 7, 8, 9],
      mayamalavagaula: [0, 1, 4, 5, 7, 8, 11],
      mecakalyani: [0, 2, 4, 6, 7, 9, 11],
      naganandini: [0, 2, 4, 5, 7, 10, 11],
      namanarayani: [0, 1, 4, 6, 7, 8, 10],
      nasikabhusani: [0, 3, 4, 6, 7, 9, 10],
      natabhairavi: [0, 2, 3, 5, 7, 8, 10],
      natakapriya: [0, 1, 3, 5, 7, 9, 10],
      navanitam: [0, 1, 2, 6, 7, 9, 10],
      nitimati: [0, 2, 3, 6, 7, 10, 11],
      pavani: [0, 1, 2, 6, 7, 9, 11],
      ragavardhani: [0, 3, 4, 5, 7, 8, 10],
      raghupriya: [0, 1, 2, 6, 7, 10, 11],
      ramapriya: [0, 1, 4, 6, 7, 9, 10],
      rasikapriya: [0, 3, 4, 6, 7, 10, 11],
      ratnangi: [0, 1, 2, 5, 7, 8, 10],
      risabhapriya: [0, 2, 4, 6, 7, 8, 10],
      rupavati: [0, 1, 3, 5, 7, 10, 11],
      sadvidhamargini: [0, 1, 3, 6, 7, 9, 10],
      salaga: [0, 1, 2, 6, 7, 8, 9],
      sanmukhapriya: [0, 2, 3, 6, 7, 8, 10],
      sarasangi: [0, 2, 4, 5, 7, 8, 11],
      senavati: [0, 1, 3, 5, 7, 8, 9],
      shankarabharanam: [0, 2, 4, 5, 7, 9, 11],
      shubhapantuvarali: [0, 1, 3, 6, 7, 8, 11],
      simhendramadhyama: [0, 2, 3, 6, 7, 8, 11],
      sucaritra: [0, 3, 4, 6, 7, 8, 9],
      sulini: [0, 3, 4, 5, 7, 9, 11],
      suryakanta: [0, 1, 4, 5, 7, 9, 11],
      suvarnangi: [0, 1, 3, 6, 7, 9, 11],
      tanarupi: [0, 1, 2, 5, 7, 10, 11],
      vacaspati: [0, 2, 4, 6, 7, 9, 10],
      vagadhisvari: [0, 3, 4, 5, 7, 9, 10],
      vakulabharanam: [0, 1, 4, 5, 7, 8, 10],
      vanaspati: [0, 1, 2, 5, 7, 9, 10],
      varunapriya: [0, 2, 3, 5, 7, 10, 11],
      visvambhari: [0, 1, 4, 6, 7, 10, 11],
      yagapriya: [0, 3, 4, 5, 7, 8, 9]
    },
    indians: {
      hindu: [0, 2, 4, 5, 7, 8, 10],
      'indian pentatonic': [0, 4, 5, 7, 11],
      'asawari thaat': [0, 2, 3, 5, 7, 8, 10],
      'bhairavi thaat': [0, 1, 3, 5, 7, 8, 10],
      'bhairav thaat': [0, 1, 4, 5, 7, 8, 11],
      'bhairubahar thaat': [0, 1, 4, 5, 7, 9, 11],
      'bilawal thaat': [0, 2, 3, 5, 7, 9, 11],
      'kafi thaat': [0, 2, 3, 5, 7, 9, 10],
      'kalyan thaat (yaman)': [0, 2, 4, 6, 7, 9, 11],
      'khammaj thaat': [0, 2, 4, 5, 7, 9, 10],
      'marwa thaat': [0, 1, 4, 6, 7, 9, 11],
      'pilu thaat': [0, 2, 3, 5, 7, 8, 11],
      'purvi thaat': [0, 1, 4, 6, 7, 8, 10]
    },
    raga1: {
      abheri: [0, 3, 5, 7, 10],
      abhogi: [0, 2, 3, 5, 9],
      adana: [0, 2, 3, 5, 7, 8, 10],
      'ahira-lalita': [0, 1, 4, 5, 6, 9, 10],
      'ahir bhairav': [0, 1, 4, 5, 7, 9, 10],
      'ahiri todi': [0, 1, 3, 5, 7, 9, 10],
      airavati: [0, 2, 4, 6, 7, 9],
      'alhaiya bilaval': [0, 2, 4, 5, 7, 9, 10, 11],
      amarasenapriya: [0, 2, 3, 6, 7, 11],
      ambika: [0, 2, 3, 6, 7, 9, 11],
      amritavarshini: [0, 4, 6, 7, 11],
      anandabhairavi: [0, 2, 3, 5, 7, 8, 9, 10],
      andolika: [0, 2, 5, 7, 9, 10],
      'antara kaishiaki': [0, 4, 7, 10],
      arabhi: [0, 2, 5, 7, 9],
      arunajualita: [0, 2, 3, 6, 7, 9, 11],
      'asavari (asaveri)': [0, 1, 3, 5, 7, 8, 10],
      'audav tukhari': [0, 2, 3, 5, 8],
      baduhari: [0, 4, 5, 7, 9, 10],
      bageshri: [0, 2, 3, 5, 7, 9, 10],
      'bageshri 2': [0, 2, 3, 5, 9, 10],
      bahar: [0, 2, 3, 5, 7, 9, 10, 11],
      'bairagi (baira)': [0, 1, 5, 7, 10],
      barbara: [0, 2, 4, 6, 9, 10],
      basant: [0, 1, 4, 6, 7, 8, 11],
      bauli: [0, 1, 4, 7, 8, 11],
      bhankar: [0, 1, 4, 5, 6, 8, 9],
      bhanumanjari: [0, 3, 4, 5, 7, 10],
      bhanumati: [0, 1, 2, 5, 7, 9, 10],
      bhatiyar: [0, 1, 4, 5, 6, 7, 9, 11],
      bhavani: [0, 1, 3, 6, 7, 8, 10],
      'bhavani 2': [0, 2, 5, 9],
      'bhimpalasi *': [0, 3, 5, 7, 10, 12, 10, 9, 7, 5, 3, 2, 0],
      'bhinna pancama': [0, 2, 5, 7, 8, 11],
      'bhinna shadja': [0, 4, 5, 9, 11],
      bhogachayanata: [0, 3, 4, 5, 7, 9, 10],
      'bhup (bhopali)': [0, 2, 4, 7, 9],
      bhupalam: [0, 1, 3, 7, 8],
      'bhupala todi': [0, 1, 3, 7, 8],
      bhupeshwari: [0, 2, 4, 7, 8],
      bhusavati: [0, 2, 4, 6, 7, 9, 10],
      'bibhas (bhairava)': [0, 1, 3, 7, 8],
      'bibhas (marva)': [0, 1, 4, 7, 9],
      'bihag *': [0, 4, 5, 7, 11, 12, 11, 9, 7, 6, 4, 2, 0],
      bilahari: [0, 2, 4, 7, 9],
      bilashkhani: [0, 1, 3, 5, 7, 8, 10],
      bilwadala: [0, 4, 9],
      bindumalini: [0, 1, 4, 5, 7, 9, 10],
      'brindabani sarang': [0, 2, 5, 7, 10, 11],
      budhamanohari: [0, 2, 4, 5, 7],
      camara: [0, 2, 3, 6, 7, 8, 10],
      chandrajyoti: [0, 1, 2, 6, 7, 9],
      'chandrakauns (kafi)': [0, 3, 5, 9, 10],
      'chandrakauns (kiravani)': [0, 3, 5, 8, 11],
      'chandrakauns (modern)': [0, 3, 5, 9, 11],
      charukeshi: [0, 2, 4, 5, 7, 8, 10],
      chaturangini: [0, 2, 4, 6, 7, 10, 11],
      'chaturangini 2': [0, 2, 4, 6, 7, 11],
      'chaya nat': [0, 2, 4, 5, 6, 7, 9, 11],
      'chaya vati': [0, 1, 4, 5, 9, 11],
      'chaya todi': [0, 1, 3, 6, 8],
      chinthamani: [0, 2, 3, 6, 7, 8, 9, 10],
      'chinthamani 2': [0, 2, 3, 6, 7, 8, 10],
      chitthakarshini: [0, 1, 3, 5, 8],
      cudamani: [0, 3, 4, 5, 7, 8, 10],
      darbar: [0, 2, 5, 7, 9, 10],
      desh: [0, 2, 5, 7, 11],
      deshgaur: [0, 1, 7, 8, 11],
      deshi: [0, 2, 3, 5, 7, 8, 9, 10],
      'deshi 2': [0, 2, 3, 5, 7, 9, 11],
      'deshi 3': [0, 2, 3, 5, 7, 8, 11],
      'desh malhar': [0, 2, 4, 5, 7, 9, 10, 11],
      desisimharavam: [0, 2, 3, 6, 7, 9, 10],
      deskar: [0, 2, 4, 7, 9],
      'desya todi': [0, 3, 5, 7, 8, 10],
      devakriya: [0, 2, 5, 7, 9],
      devamani: [0, 3, 4, 7, 8, 11],
      devarangini: [0, 2, 4, 5, 7, 9],
      'devaranjani 2 (devaranji)': [0, 5, 7, 8, 11],
      devarashtra: [0, 3, 4, 6, 7, 8, 11],
      'dhani (suddha dhanyasi)': [0, 3, 5, 7, 10],
      'dhauta pancama': [0, 3, 4, 6, 7, 8, 11],
      dhavalangam: [0, 1, 4, 6, 7, 8],
      dhavalashri: [0, 4, 6, 7, 9],
      dhipaka: [0, 1, 4, 6, 7, 8, 11],
      dhunibinnashadjam: [0, 1, 3, 5, 7, 8, 11],
      dipak: [0, 2, 4, 5, 6, 7],
      dumyaraga: [0, 2, 3, 6, 7, 9, 11],
      durga: [0, 2, 5, 7, 9],
      dvigandharabushini: [0, 2, 3, 4, 7, 8, 9],
      gamakakriya: [0, 1, 4, 6, 7, 11],
      gamakasamantam: [0, 1, 3, 6, 7, 8, 11],
      gambhiranata: [0, 4, 5, 7, 11],
      ganasamavarali: [0, 1, 2, 5, 7, 8, 11],
      ganavaridhi: [0, 3, 4, 5, 7, 9, 10],
      gandharavam: [0, 1, 3, 5, 7, 10],
      gangatarangini: [0, 4, 5, 6, 8, 11],
      'gaud sarang': [0, 2, 4, 5, 6, 7, 9, 11],
      gaula: [0, 1, 4, 5, 7, 10],
      gauri: [0, 1, 5, 7, 11],
      gaurikriya: [0, 3, 6, 7, 10, 11],
      'gauri velavali': [0, 2, 3, 5, 7, 9],
      geyahejjajji: [0, 1, 4, 5, 7, 8],
      ghandarva: [0, 1, 2, 6, 7, 10, 11],
      ghantana: [0, 2, 3, 5, 8, 11],
      girija: [0, 4, 5, 8, 11],
      girvani: [0, 1, 3, 6, 7, 8, 9],
      gitapriya: [0, 2, 4, 6, 7, 8, 11],
      gopikatilaka: [0, 2, 3, 6, 7, 10],
      gopikavasantam: [0, 3, 5, 7, 8, 10],
      gopriya: [0, 2, 4, 6, 8, 10],
      'gorakh kalyan': [0, 2, 5, 7, 9, 10],
      gowleeswari: [0, 1, 5, 8],
      guhamanohari: [0, 2, 5, 9, 10],
      'gunakri (gunakali)': [0, 1, 5, 7, 8],
      'gurjari todi': [0, 1, 3, 6, 8, 10],
      'hamir kalyani': [0, 2, 4, 5, 6, 7, 9, 11],
      'hamsadhvani (hansadhvani)': [0, 2, 4, 7, 11],
      hamsagiri: [0, 3, 4, 6, 7, 10, 11],
      hamsalata: [0, 2, 4, 6, 7, 8, 11],
      hamsanada: [0, 2, 6, 7, 11],
      hamsanandi: [0, 1, 4, 6, 9, 11],
      'hamsanandi 2': [0, 1, 4, 5, 8, 11],
      hamsanarayani: [0, 1, 4, 6, 7, 11],
      'hamsa vinodini': [0, 2, 4, 5, 9, 11],
      'hansadhvani (hamsadhvani)': [0, 2, 4, 7, 11],
      harikauns: [0, 3, 6, 8, 10],
      'hari nata': [0, 4, 5, 7, 9, 11],
      harini: [0, 2, 4, 5, 7, 9, 10],
      haripriya: [0, 2, 4, 5, 7, 8, 11],
      'haripriya 2': [0, 2, 5, 8],
      hejjajji: [0, 1, 4, 6, 8, 9],
      'hindol (sunada vinodini)': [0, 4, 6, 9, 11],
      hindola: [0, 3, 5, 8, 10],
      hindolita: [0, 4, 5, 9, 11],
      indupriya: [0, 1, 4, 6, 7, 8],
      jaganmohanam: [0, 2, 6, 7, 8, 10],
      'jait kalyan': [0, 2, 4, 7, 9],
      janasammodini: [0, 2, 4, 7, 8],
      janjhuti: [0, 2, 4, 5, 7, 9, 10],
      jaunpuri: [0, 2, 3, 5, 7, 8, 10],
      jayakauns: [0, 3, 5, 6, 10],
      jeyasuddhamalavi: [0, 1, 4, 5, 7, 10, 11],
      'jhankara bhramavi': [0, 2, 3, 5, 7, 8, 9],
      jinavali: [0, 1, 2, 6, 7, 8, 11],
      jivantika: [0, 1, 5, 7, 9, 11],
      jivantini: [0, 3, 6, 7, 10, 11],
      jog: [0, 3, 4, 5, 7, 10],
      jogiya: [0, 1, 4, 5, 7, 8, 10],
      jotismatti: [0, 3, 4, 6, 7, 8, 10],
      jyoti: [0, 4, 6, 7, 8, 10],
      kaikavasi: [0, 2, 3, 6, 7, 10, 11],
      'kaishikiranjani (kaushiranjani)': [0, 2, 3, 5, 8, 11],
      kalagada: [0, 1, 4, 7, 8, 9],
      kalahamsa: [0, 3, 4, 5, 7, 8, 9],
      kalakanthi: [0, 1, 4, 5, 7, 8, 9],
      'kalakanthi 2': [0, 1, 5, 7, 8, 9],
      kalamurti: [0, 1, 3, 6, 7, 8, 10],
      kalavati: [0, 1, 4, 5, 7, 9],
      kalingada: [0, 1, 4, 5, 7, 8, 11],
      kalyana: [0, 2, 3, 5, 7, 8, 11],
      'kalyani keseri': [0, 2, 4, 6, 7, 9],
      kamalamanohari: [0, 4, 5, 7, 8, 11],
      'kamalamanohari 2': [0, 4, 5, 7, 8, 10],
      kambhoji: [0, 2, 4, 5, 7, 9],
      kanakambari: [0, 1, 2, 5, 7, 8, 9],
      kannadabangala: [0, 1, 4, 5, 7, 8],
      kapijingla: [0, 2, 3, 5, 9, 10],
      kashyapi: [0, 1, 3, 7, 8, 10],
      kasiramakriya: [0, 1, 4, 6, 7, 8, 11],
      kaushikdhvani: [0, 4, 5, 9, 11],
      'kaushiranjani / kaishikiranjani': [0, 2, 3, 5, 8, 11],
      kedar: [0, 2, 4, 5, 6, 7, 9, 11],
      kedaram: [0, 2, 4, 5, 7, 11],
      keseri: [0, 2, 4, 5, 7, 8, 9],
      khamaj: [0, 2, 4, 5, 7, 9, 10, 11],
      'khamaji durga': [0, 4, 5, 9, 10],
      khamas: [0, 4, 5, 7, 9, 10],
      khambhavati: [0, 2, 4, 5, 7, 9, 10],
      kiranavali: [0, 2, 3, 5, 7, 8, 11],
      kirvani: [0, 2, 3, 5, 7, 8, 11],
      'kirvani *': [0, 2, 3, 7, 8, 11, 12, 11, 8, 7, 5, 3, 2, 0],
      kokila: [0, 2, 4, 7, 9],
      kokilaravam: [0, 1, 3, 5, 7, 9, 11],
      'kokil pancham': [0, 3, 5, 7, 8],
      kshanika: [0, 1, 5, 8, 11],
      kumarapriya: [0, 1, 2, 8, 11],
      kumbhini: [0, 1, 2, 6, 7, 9, 11],
      kumud: [0, 2, 4, 7, 9, 11],
      'kumudki (kumurdaki)': [0, 2, 4, 6, 11],
      kuntala: [0, 2, 4, 6, 7, 8, 9],
      'kuntalavarali (kuntvarali)': [0, 5, 7, 9, 10],
      kusumakaram: [0, 3, 4, 6, 7, 9, 11]
    },
    raga2: {
      lalit: [0, 1, 4, 5, 6, 9, 11],
      lalita: [0, 1, 4, 5, 6, 8, 11],
      'lalita 2': [0, 1, 4, 5, 8, 11],
      'lalit bhairav': [0, 1, 4, 5, 8, 10],
      lasaki: [0, 1, 5, 7, 10],
      latantapriya: [0, 1, 5, 7, 8],
      latika: [0, 2, 4, 7, 8, 11],
      lavangi: [0, 1, 7, 10],
      'madhava manohari': [0, 2, 3, 6, 7, 8, 11],
      'madhmat sarang': [0, 2, 5, 7, 10],
      'madhukauns (hexatonic)': [0, 3, 6, 7, 9, 10],
      'madhukauns (pentatonic)': [0, 3, 6, 7, 10],
      madhuranjani: [0, 3, 5, 7, 11],
      madhuri: [0, 4, 5, 7, 9, 10, 11],
      madhuvanti: [0, 2, 3, 6, 7, 9, 11],
      madhyamavati: [0, 2, 5, 7, 10],
      mahathi: [0, 4, 7, 10],
      malahari: [0, 1, 4, 5, 7, 8],
      'malarani (hamsanada)': [0, 2, 6, 7, 10, 11],
      malashri: [0, 4, 6, 7, 11],
      'malashri 2': [0, 4, 7],
      malayamarutam: [0, 1, 4, 7, 9, 10],
      malgunji: [0, 2, 3, 4, 5, 7, 9, 10, 11],
      'malkauns (malakosh)': [0, 3, 5, 8, 10],
      malini: [0, 1, 3, 5, 7, 8, 9],
      mamata: [0, 4, 7, 9, 11],
      'manaranjani 1': [0, 1, 4, 7, 10],
      'manaranjani 2': [0, 1, 5, 7, 9],
      manavi: [0, 2, 3, 7, 9, 10],
      mand: [0, 4, 5, 7, 9],
      mandari: [0, 1, 4, 6, 7, 11],
      manirangu: [0, 2, 3, 5, 7, 10],
      manohari: [0, 3, 5, 7, 9, 10],
      manoranjani: [0, 1, 2, 5, 7, 9, 11],
      'marga hindola': [0, 3, 5, 9, 11],
      marva: [0, 1, 4, 6, 9, 11],
      'matha kokila (matkokil)': [0, 2, 7, 9, 10],
      megh: [0, 2, 5, 7, 10],
      'megh (megh malhar)': [0, 2, 5, 7, 10, 11],
      megharanjani: [0, 1, 4, 5, 8],
      megharanji: [0, 1, 4, 5, 11],
      'mian ki malhar': [0, 2, 3, 5, 7, 9, 10, 11],
      mohanam: [0, 2, 4, 7, 9],
      mohanangi: [0, 3, 4, 7, 9],
      mruganandana: [0, 2, 4, 6, 9, 11],
      mukhari: [0, 2, 3, 5, 7, 8, 9, 10],
      multani: [0, 1, 3, 6, 7, 8, 11],
      'multani 2': [0, 3, 6, 7, 11],
      nabhomani: [0, 1, 2, 6, 7, 9, 10],
      'nabhomani 2': [0, 1, 2, 6, 7],
      nagabharanam: [0, 2, 4, 5, 7, 10, 11],
      nagagandhari: [0, 2, 5, 7, 9, 11],
      nagasvaravali: [0, 4, 5, 7, 9],
      nalinakanti: [0, 2, 4, 5, 7, 11],
      nandkauns: [0, 3, 4, 5, 7, 9, 10],
      narayani: [0, 2, 5, 7, 9, 10],
      narmada: [0, 1, 4, 6, 7, 8, 10],
      nasamani: [0, 3, 4, 6, 7, 9, 10],
      nata: [0, 3, 5, 7, 11],
      natabharanam: [0, 1, 3, 5, 7, 9, 10],
      nattaikurinji: [0, 2, 4, 5, 9, 10],
      navamanohari: [0, 2, 5, 7, 8, 10],
      nayaki: [0, 2, 3, 5, 7, 10],
      'nayaki kanada': [0, 2, 3, 5, 7, 9, 10],
      neelangi: [0, 2, 3, 6, 8, 9],
      neroshta: [0, 2, 4, 9, 11],
      nigamagamini: [0, 4, 6, 11],
      nileshwari: [0, 3, 5, 6, 7, 10],
      nisada: [0, 2, 3, 6, 7, 10, 11],
      nishadi: [0, 2, 6, 7, 9, 11],
      none: [0, 3, 4, 5, 7, 10, 11],
      ongkari: [0, 6, 7],
      padi: [0, 1, 5, 7, 8, 11],
      pahadi: [0, 2, 4, 5, 7, 8, 9, 10, 11],
      palasi: [0, 2, 3, 5, 7, 10],
      pancama: [0, 1, 4, 6, 9, 11],
      pantuvarali: [0, 1, 4, 6, 7, 8, 11],
      paraj: [0, 1, 4, 5, 7, 8, 11],
      paraju: [0, 4, 5, 7, 8, 11],
      partiravam: [0, 1, 4, 6, 7, 9, 11],
      patdip: [0, 2, 3, 5, 7, 9, 11],
      phenadyuti: [0, 1, 2, 5, 7, 8, 10],
      'phenadyuti 2': [0, 1, 5, 7, 8, 10],
      'pilu *': [0, 3, 5, 7, 11, 12, 10, 8, 7, 5, 3, 2, 0],
      pratapa: [0, 1, 4, 6, 7, 8, 10],
      priyadharshini: [0, 2, 5, 8, 11],
      puriya: [0, 1, 4, 6, 7, 9, 11],
      'puriya 2': [0, 1, 4, 6, 9, 11],
      'puriya dhanashri': [0, 1, 4, 6, 7, 8, 11],
      'puriya kalyan': [0, 1, 4, 6, 7, 9, 11],
      purnalalita: [0, 2, 3, 5, 7],
      'purna pancama': [0, 1, 4, 5, 7, 8],
      puruhutika: [0, 5, 7, 9, 11],
      purvaholika: [0, 5, 7, 9, 11],
      pushpalithika: [0, 2, 3, 5, 7, 10],
      putrika: [0, 1, 2, 8, 9],
      ragamalini: [0, 1, 4, 5, 7, 9],
      rageshri: [0, 2, 4, 5, 9, 10, 11],
      'rageshri 2 (rageshwari)': [0, 2, 4, 5, 9, 10],
      rajeshwari: [0, 3, 5, 9, 11],
      ramamanohari: [0, 1, 4, 6, 7, 9, 10],
      'ramamanohari 2': [0, 4, 5, 7, 8, 11],
      'ramdasi malhar': [0, 2, 3, 4, 5, 7, 9, 10, 11],
      'ramkali (ramakri)': [0, 1, 4, 5, 6, 7, 8, 11],
      'ramkali 2': [0, 1, 3, 7, 8],
      rangini: [0, 2, 3, 6, 9, 11],
      ranjani: [0, 2, 3, 6, 9, 11],
      rasamanjari: [0, 3, 4, 6, 7, 10, 11],
      'rasamanjari 2': [0, 3, 4, 6, 7, 11],
      rasavali: [0, 1, 5, 7, 9, 10],
      'rasika ranjani': [0, 1, 4, 7, 9],
      rasranjani: [0, 2, 5, 9, 11],
      ratipriya: [0, 2, 4, 6, 7, 8, 10],
      ratnakanthi: [0, 2, 4, 6, 7, 11],
      ravikriya: [0, 1, 2, 6, 7, 10, 11],
      reva: [0, 1, 4, 7, 8],
      revagupti: [0, 1, 4, 7, 8],
      'rudra pancama': [0, 1, 4, 5, 9, 10],
      rukmangi: [0, 1, 3, 7, 10],
      sahera: [0, 2, 4, 6, 8, 10],
      sailadesakshi: [0, 3, 4, 5, 7, 9, 11],
      salagavarali: [0, 1, 3, 7, 9, 10],
      salanganata: [0, 1, 5, 7, 8],
      samanta: [0, 2, 4, 5, 7, 10, 11],
      'samudhra priya': [0, 3, 6, 7, 10],
      'sanjh ka hindol': [0, 4, 6, 9, 11],
      'sankara (shankara)': [0, 2, 4, 7, 9, 11],
      santanamanjari: [0, 3, 4, 6, 7, 8, 9],
      sarasanana: [0, 2, 4, 5, 8, 11],
      sarasvati: [0, 2, 6, 7, 9, 10],
      'saravati (sharavati)': [0, 4, 5, 7, 8, 9],
      sarvasri: [0, 5, 7],
      saugandhini: [0, 1, 6, 7, 8],
      saurashtra: [0, 1, 4, 5, 7, 8, 9, 11],
      sauviram: [0, 1, 3, 6, 7, 9, 11],
      saveri: [0, 1, 5, 7, 8],
      savitri: [0, 4, 5, 7, 10, 11],
      senagrani: [0, 1, 3, 5, 7, 8, 9],
      shailaja: [0, 3, 7, 8, 10],
      shankarabharanam: [0, 2, 4, 5, 7, 9, 11],
      shilangi: [0, 4, 6, 7, 11],
      shobhavari: [0, 2, 5, 7, 8],
      shri: [0, 1, 4, 6, 7, 8, 11],
      'shri kalyan': [0, 2, 6, 7, 9],
      shubravarni: [0, 2, 6, 9, 10],
      'shuddh kalyan': [0, 2, 4, 6, 7, 9, 11],
      'simharava (sinharavam)': [0, 2, 3, 6, 7, 10],
      simhavahini: [0, 4, 5, 7, 8, 11],
      'sindhi-bhairavi': [0, 1, 2, 3, 4, 5, 7, 8, 10, 11],
      sindhura: [0, 2, 3, 5, 7, 9, 10, 11],
      'sindhu ramakriya': [0, 4, 5, 7, 8, 11],
      'sindhura kafi': [0, 2, 3, 5, 7, 11],
      'siva kambhoji': [0, 2, 4, 5, 7, 10],
      'sivaranjini (shivranjani)': [0, 2, 3, 7, 9],
      sohani: [0, 1, 4, 6, 7, 9, 11],
      sohini: [0, 1, 4, 5, 8, 11],
      sorati: [0, 2, 5, 7, 9, 10, 11],
      sowrashtram: [0, 1, 4, 5, 7, 9, 11],
      sriraga: [0, 2, 3, 5, 7, 9, 10],
      sriranjani: [0, 2, 3, 5, 9, 10],
      srutiranjani: [0, 2, 4, 6, 7, 8, 9],
      sthavarajam: [0, 1, 3, 6, 7, 9, 10],
      'suddha bangala': [0, 2, 3, 5, 7, 9],
      'suddha dhanyasi (dhani)': [0, 3, 5, 7, 10],
      'suddha mukhari': [0, 1, 2, 5, 8, 9],
      'suddha pancama': [0, 1, 4, 5, 6, 8, 11],
      'suddha ramakriya': [0, 1, 4, 6, 7, 8, 11],
      'suddha saveri': [0, 2, 5, 7, 9],
      'suddha simantini': [0, 1, 3, 5, 7, 8],
      'suddha todi': [0, 1, 3, 5, 8, 10],
      'suha kanada': [0, 2, 3, 7, 8, 10],
      'suha sughrai': [0, 2, 3, 5, 7, 10],
      sumukam: [0, 2, 6, 11],
      suposhini: [0, 2, 5, 7, 9, 10],
      supradhipam: [0, 1, 4, 5, 7, 9, 11],
      surati: [0, 2, 4, 5, 7, 9, 10],
      'sur malhar': [0, 2, 5, 7, 9, 10, 11],
      surya: [0, 3, 5, 9, 10],
      sutradhari: [0, 2, 5, 7, 8],
      syamalam: [0, 2, 3, 6, 7, 8],
      takka: [0, 3, 5, 7, 8, 11],
      tanukirti: [0, 1, 2, 5, 7, 10, 11],
      tarangini: [0, 2, 4, 5, 7, 8, 10],
      'tilang *': [0, 2, 4, 5, 7, 9, 11, 12, 10, 9, 7, 5, 4, 2, 0],
      tivravahini: [0, 1, 3, 6, 7, 9, 10],
      trimurti: [0, 2, 3, 7, 8, 10],
      trishuli: [0, 3, 4, 5, 7, 9, 11],
      udayaravicandrika: [0, 3, 5, 7, 11],
      'udhayaravi chandrika': [0, 3, 5, 7, 10],
      vaijayanti: [0, 2, 6, 7, 11],
      valaji: [0, 4, 7, 9, 10],
      vamsavathi: [0, 1, 3, 6, 7, 10, 11],
      varali: [0, 1, 2, 6, 7, 8, 11],
      varamu: [0, 3, 5, 9, 10],
      varini: [0, 3, 7, 8, 10],
      vasantha: [0, 2, 3, 5, 7, 8, 11],
      'vasantha 2': [0, 1, 4, 5, 9, 11],
      'vasantha (bhairavi)': [0, 1, 4, 5, 8, 10],
      'vativasanta (bhairavi)': [0, 1, 4, 5, 7, 8, 10],
      vegavahini: [0, 1, 4, 5, 7, 9, 10],
      velavali: [0, 2, 3, 5, 7, 9, 11],
      'vibhas (bhairava)': [0, 1, 4, 7, 8],
      'vibhas (marva)': [0, 1, 4, 7, 9],
      'vibhavari (revati)': [0, 1, 5, 7, 10],
      vijayanagari: [0, 2, 3, 6, 7, 9],
      vijayasri: [0, 1, 2, 6, 7, 11],
      vijayavasanta: [0, 4, 6, 7, 10, 11],
      vilasini: [0, 2, 4, 5, 7, 11],
      viravasantham: [0, 2, 3, 5, 7, 10, 11],
      vivardhini: [0, 2, 4, 5, 7, 10],
      viyogavarali: [0, 1, 3, 5, 8, 11],
      vutari: [0, 4, 6, 7, 9, 10],
      'yaman kalyan': [0, 2, 4, 5, 6, 7, 9, 11],
      'yamuna kalyani': [0, 2, 4, 6, 7, 9],
      yashranjani: [0, 1, 6, 7, 8],
      zilaf: [0, 4, 5, 7, 8],
      zilla: [0, 2, 3, 4, 5, 7, 9, 10]
    }
  };
  // ************************************************************************************************************************************
  // ************************************************************************************************************************************
  // ************************************************************************************************************************************

  public structures: {[key: string]: any} = {};
  public mainStructures = {};
  public families: string[] = [];

  constructor(
    public notesService: NotesService
  ) {
    for (const family in this.byFamily) {
      if (this.byFamily.hasOwnProperty(family)) {
        this.families.push(family);
        Object.assign(this.structures, this.byFamily[family]);
        if (['commons', 'modes', 'moreblues', 'jazzmore', 'bebop'].indexOf(family)  !== -1) {
          Object.assign(this.mainStructures, this.byFamily[family]);
        }
      }
    }
  }
  getStructure(name: string): number[] {
    const s = this.structures[name];
    if (typeof(s) === 'undefined') {
      console.log('ERROR: scale "' + name + '" not found.');
      return [];
    }
    return s;
  }
  isSharp(note12: number): boolean {
    return ([1, 3, 6, 8, 10].indexOf(note12) !== -1);
  }
  getFirstDiatonicNote(note12: number, structure: number[], doremi: boolean): string {
    // Find the first not sharp note in structure
    let notSharp12Found = -1;
    let index = 0;
    let notSharpRank = 0;
    let notSharpOffset = 0;
    while ((notSharp12Found === -1) && (index < structure.length)) {
      const notSharp12 = (note12 + structure[index]) % 12;
      if (!this.isSharp(notSharp12)) {
        notSharp12Found = notSharp12;
        notSharpOffset = structure[index];
        notSharpRank = index;
      }
      index++;
    }
    // This note is correct
    const notSharpFound = this.notesService.disp(notSharp12Found, doremi);
    // Get the root from this note (this not sharp note to the root)
    return this.notesService.getStrictNoteName(
      notSharpFound,
      7 - notSharpRank, // rank - 1
      12 - notSharpOffset,
      doremi
    );
  }
  getNoteNames(
    root12: number,
    name: string,
    doremi: boolean,
    strictForDiatonic = false,
    withAStartNoteName = ''
  ) {
    const structure = this.getStructure(name);
    const notes = ['', '', '', '', '', '', '', '', '', '', '', ''];
    const isDiatonic = strictForDiatonic
      ? this.isDiatonic(structure)
      : false;
    if (isDiatonic) {
      if (withAStartNoteName !== '') { // We could have A# major as first note
        notes[root12] = withAStartNoteName;
      } else {
        notes[root12] = this.getFirstDiatonicNote(root12, structure, doremi);
      }
    }
    structure.forEach((delta, index) => {
      if (index > 0) {
        const note12 = (root12 + delta + 12) % 12;
        let note = this.notesService.disp(note12, doremi);
        if (isDiatonic) {
          note = this.notesService.getStrictNoteName(
            notes[root12],
            index, // rank - 1
            note12 - root12,
            doremi
          );
        }
        notes[note12] = note;
      }
    });
    return notes;
  }
  getNames(mainOnly?: boolean) {
    const result: string[] = [];
    const s: {} = mainOnly ? this.mainStructures : this.structures;
    for (const name in s) {
      if (s.hasOwnProperty(name)) {
        result.push(name);
      }
    }
    return result;
  }
  isDiatonic(structure: number[]) {
    if (structure.length !== 7) {
      return false;
    }
    let mask = '';
    for (let i = 0; i < 7; i++) {
      const delta = (i > 0) ?
        structure[i] - structure[i - 1] :
        structure[0] + 12 - structure[6];
      if ((delta !== 1) && (delta !== 2)) {
        mask += 'X';
      } else {
        mask += (delta === 1) ? 'H' : 'W';
      }
    }
    return (mask + mask + mask).indexOf('WWWHWWH') !== -1;
  }
  getNamesOfFamilies(families: string[]) {
    const result: string[] = [];
    families.forEach((family) => {
      for (const name in this.byFamily[family]) {
        if (this.byFamily[family].hasOwnProperty(name)) {
          result.push(name);
        }
      }
    });
    return result;
  }
  delta(index: number) {
    return [' ', 'H', 'W', '3', '4', '5', '6', '7', '8', '9', '10', '11'][index];
  }
  selectSignatureFromScale(fromNoteName: string, isMajor: boolean, doremi: boolean) {
    if (typeof fromNoteName === 'undefined') {
      return;
    }
    if ((isMajor) && (fromNoteName === 'C#')) {
      return 'Db';
    }
    if ((!isMajor) && (fromNoteName === 'Db')) {
      return 'C#';
    }
    if ((isMajor) && (fromNoteName === 'D#')) {
      return 'Eb';
    }
    if ((!isMajor) && (fromNoteName === 'Eb')) {
      return 'D#';
    }
    if ((isMajor) && (fromNoteName === 'G#')) {
      return 'Ab';
    }
    if ((!isMajor) && (fromNoteName === 'Ab')) {
      return 'G#';
    }
    if (fromNoteName === 'Gb') {
      return 'F#';
    }
    if (fromNoteName === 'A#') {
      return 'Bb';
    }
    // ------------------------------- Doremi
    if ((isMajor) && (fromNoteName === 'Do#')) {
      return 'Réb';
    }
    if ((!isMajor) && (fromNoteName === 'Réb')) {
      return 'Do#';
    }
    if ((isMajor) && (fromNoteName === 'Ré#')) {
      return 'Mib';
    }
    if ((!isMajor) && (fromNoteName === 'Mib')) {
      return 'Ré#';
    }
    if ((isMajor) && (fromNoteName === 'Sol#')) {
      return 'Lab';
    }
    if ((!isMajor) && (fromNoteName === 'Lab')) {
      return 'Sol#';
    }
    if (fromNoteName === 'Solb') {
      return 'Fa#';
    }
    if (fromNoteName === 'La#') {
      return 'Sib';
    }
    return fromNoteName;
  }
  getStructureAndNoteNames(
    name: string,
    root12: number,
    strict: boolean,
    doremi: boolean
  ): {
    delta: number,
    noteName: string,
    intervalDisplay: string
  }[] {
    const result: {
      delta: number,
      noteName: string,
      intervalDisplay: string
    }[] = [];
    const diatonic = (this.getStructure(name).length === 7);
    let rootNoteName: string = this.notesService.disp(root12, doremi);
    if ((diatonic) && (strict)) {
      if (name.indexOf('major') !== -1) {
        rootNoteName = this.selectSignatureFromScale (rootNoteName, true, doremi) || '';
      }
      if (name.indexOf('minor') !== -1) {
        rootNoteName = this.selectSignatureFromScale (rootNoteName, false, doremi) || '';
      }
    }
    this.getStructure(name).forEach((interval, index) => {
        let noteDisplay = this.notesService.disp(
          root12 + interval,
          doremi
        );
        if ((diatonic) && (strict)) {
            noteDisplay = this.notesService.getStrictNoteName(
              rootNoteName,
              index,
              interval,
              doremi
            );
        }
        const intDisplay = this.getIntervalDisplayByIndex(name, index);
        result.push({
            delta: interval,
            noteName: noteDisplay,
            intervalDisplay: intDisplay
        });
    });
    return result;
  }
  getIntervalDisplay(intervalIndex: number, noteInterval: number) {
    let intDisplay = this.intervalsDisplay[noteInterval];
    if ((intDisplay === 'b3') && (intervalIndex === 1)) {
      intDisplay = '#2';
    }
    if ((intDisplay === 'b5') && (intervalIndex === 3)) {
      intDisplay = '#4';
    }
    if ((intDisplay === '#5') && (intervalIndex === 5)) {
      intDisplay = 'b6';
    }
    if ((intDisplay === 'm7') && (intervalIndex === 5)) {
      intDisplay = '#6';
    }
    return intDisplay;
  }
  getIntervalDisplayByIndex(name: string, intervalIndex: number) {
    const interval = this.getStructure(name)[intervalIndex];
    return this.getIntervalDisplay (intervalIndex, interval);
  }
  nameToReference(name: string) {
    const n = name.toLowerCase();
    if (n === 'major') {
      return 'major ';
    } else if (n === 'minor') {
      return 'minor (natural)';
    }
    return n;
  }
  getSignature(root12: number, scaleName: string): string {
    // First char is the nearest note after C
    // Following char if the delta between this note and the previous one
    // etc
    let offsets: number[] = [];
    let min = 12;
    let minIndex = -1;
    this.getStructure(scaleName).forEach((offset, index) => {
      const note12 = (root12 + offset) % 12;
      offsets.push(note12);
      if (note12 < min) {
        min = note12;
        minIndex = index;
      }
    });
    if (offsets.length === 0) {
      return '';
    }
    if (minIndex > 0) {
      for (let i = 0; i < minIndex; i++) {
        const moveIt = offsets.shift();
        if (moveIt) {
          offsets.push(moveIt);
        }
      };
    }
    let signature = offsets[0].toString(16);
    if (offsets.length > 1) {
      for (let i = 1; i < offsets.length; i++) {
        signature += (offsets[i] - offsets[i-1]).toString(16);
      }
    }
    return signature;
  }
}
